import { JaaRoute } from '../../../../utilities/Links';

export function getNewsRoute(category: string) {
  return `${JaaRoute.newsIndex}?category=${encodeURIComponent(category)}`;
}
